import React from 'react'

import LoadingSettings from 'components_new/organisms/pageLoaders/LoadingSettings'

import ConfigsOrganism from 'components_new/organisms/Configs'
import SettingsTemplate from 'components_new/templates/SettingsTemplate'

import { useConfigs } from 'redux/hooks/Configs'

const ConfigurationPage = () => {
  const { configs, loading } = useConfigs()

  const sections = Object.values(configs)

  return (
    <SettingsTemplate>
      {!loading && sections.length > 0 ? (
        <ConfigsOrganism />
      ) : (
        <LoadingSettings />
      )}
    </SettingsTemplate>
  )
}

export default ConfigurationPage
